module.exports = __webpack_public_path__ + "static/media/importICS1.213a1b26.png";